// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2Qixc","colMin":"styles_colMin__1KkMi","colCheckbox":"styles_colCheckbox__1numy"};